export default __webpack_public_path__ + "static/media/digitalcard_ticket.b69e6e54.svg";